import { render } from "./paySuccessPage.vue?vue&type=template&id=9732b3f4&scoped=true"
import script from "./paySuccessPage.vue?vue&type=script&lang=js"
export * from "./paySuccessPage.vue?vue&type=script&lang=js"

import "./paySuccessPage.vue?vue&type=style&index=0&id=9732b3f4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-9732b3f4"

export default script